import {
    CCard,
    CCardBody,
    CCardGroup,
    CForm,
    CCol,
    CFormInput,
    CFormLabel,
    CRow,
    CFormSelect,
    CFormCheck,
    CSpinner,
    CFormTextarea,
    CButtonGroup,
    CLink
} from '@coreui/react';
import React, { Component } from 'react';
import AppButton from 'src/components/AppButton'
import {
    cilArrowBottom,
    cilArrowTop,
    cilCheck,
    cilDelete,
    cilPlus,
    cilSave,
    cilSend,
    cilTrash
} from '@coreui/icons'
import ServerConnector from 'src/ServerConnector'
import PageHeader from 'src/components/PageHeader'
import Multiselect from 'multiselect-react-dropdown';
import DatePicker from 'react-date-picker';
import { getDBDate, getDateObject } from 'src/util/DateUtil';
import { random } from 'src/util/MathUtil';
import { object } from 'prop-types';
import { getFileExtensionFromName, urlDecode, urlEncode } from 'src/util/StringUtil';

const inputTypes = [
    {
        id: "TEXT",
        name: "Text Field"
    },
    {
        id: "LIST",
        name: "Drop Down"
    },
    {
        id: "CHECK",
        name: "Check Box"
    },
    {
        id: "RADIO",
        name: "Radio Button"
    },
];

class SendMessage extends Component {
    
    constructor(props) {
        super(props);
        this.state = {
            message_seq: this.props.page_data.message_seq,
            messageType: this.props.page_data.messageType ? this.props.page_data.messageType : "MESSAGE",
            inputs: {
                message: "",
                messageerr: "",
                uploadImage: "",
                uploadImageerr: "",
                uploadPdf: "",
                uploadPdferr: "",
                uploadedImageUrl: "",
                uploadedPdfUrl: "",
                fromDate: null,
                fromDateerr: "",
                toDate: null,
                toDateerr: "",
                options: [
                    {
                        inputSeq: -1,
                        optionText: "",
                        isDeleted: false
                    },
                    {
                        inputSeq: -1,
                        optionText: "",
                        isDeleted: false
                    }
                ],
                optionserr: "",
            },
            messageGroupList: [],
            messageGroupDropdownSpinner: false,
            selectedGroup: [],
            selectedGroupError: "",
            studentForSet: [],
        }

        this.today = new Date();
    }

    componentDidMount() {
        
        this.loadMessageGroups();

        if (this.state.message_seq != -999) {

            this.loadData();
            this.loadRecipients();
        }
    }

    loadData() {

        this.props.showPageSpinner(true);

        let connector = new ServerConnector();
        let dataMap = {
            "_action_code": "VIEW_GROUP_MESSAGE",
            "message_seq": this.state.message_seq
        }

        connector.postData(dataMap, (data) => { // success

            this.props.showPageSpinner(false);

            let inputs = this.state.inputs;
            inputs["message"] = urlDecode(data.data[0].message);

            if (data.data[0].available_from) {
                inputs["fromDate"] = getDateObject(data.data[0].available_from);
            }
            if (data.data[0].available_to) {
                inputs["toDate"] = getDateObject(data.data[0].available_to);
            }

            if (data.data[0].image_file != null && data.data[0].image_file != "null") {
                inputs["uploadedImageUrl"] = data.data[0].image_file;
            }
            if (data.data[0].attach_file != null && data.data[0].attach_file != "null") {
                inputs["uploadedPdfUrl"] = data.data[0].attach_file;
            }
            this.setState({
                inputs: inputs
            });

            if (this.state.messageType == "MSG_POLL" || this.state.messageType == "MSG_FORM") {
                this.loadOptions();
            }
        }, (err_cd, msg, data) => { // failure

            this.props.showPageSpinner(false);

            this.props.showAlert("Error", msg, "Ok", null, () => {
                this.props.navigate("messages_list")
            })
        })
    }
    
    loadRecipients() {

        this.setState({
            messageGroupDropdownSpinner: true,
        });

        let connector = new ServerConnector();
        let dataMap = {
            "_action_code": "GET_MESSAGE_RECEPIENTS",
            "message_seq": this.state.message_seq
        }

        connector.postData(dataMap, (data) => { // success

            var selectedGroups = [];
            for (var i=0;i<data.data.length;i++) {
                const object = data.data[i];
                selectedGroups.push({name: object.post_to_name, id: object.post_to_seq});
            }

            this.setState({
                selectedGroup: selectedGroups,
                messageGroupDropdownSpinner: false
            })
        }, (err_cd, msg, data) => { // failure

            this.props.showPageSpinner(false);

            this.props.showAlert("Error", msg, "Ok", null, () => {
                
            })
        })
    }

    loadMessageGroups() {
        this.setState({
            messageGroupDropdownSpinner: true,
        });
        let connector = new ServerConnector();
        let dataMap = {
            _action_code: "GET_ALL_STUDENT_SETS"
        }

        connector.postData(dataMap, (data) => { // success

            var activeGroups = [];
            for (var i=0;i<data.data.length;i++) {
                if (data.data[i].status == "ACTIVE") {
                    activeGroups.push(data.data[i]);
                }
            }

            this.setState({
                messageGroupDropdownSpinner: false,
                messageGroupList: activeGroups
            });
        }, (err_cd, msg, data) => { // failure
            this.setState({
                messageGroupDropdownSpinner: false,
                messageGroupList: []
            });
        })
    }

    updateInput(inputName, value) {

        let inputs = this.state.inputs;
        inputs[inputName] = value;
        inputs[inputName + "err"] = "";
        this.setState({
            inputs: inputs
        });
    }

    validateForm() {

        var isValid = true;
        let inputs = this.state.inputs;
        var selectedGroupError = "";

        if (inputs.message.length == 0) {
            inputs["messageerr"] = "Required";
            isValid = false;
        }

        if (this.state.selectedGroup.length == 0) {
            selectedGroupError = "Required";
            isValid = false;
        }

        if (this.state.messageType == "MSG_FILE") {
            if (!inputs.uploadPdf && this.state.inputs.uploadedPdfUrl.length == 0) {

                inputs["uploadPdferr"] = "Required";
                isValid = false;
            }
        }

        if (inputs.fromDate != null && inputs.toDate == null) {
            inputs["toDateerr"] = "Required";
            isValid = false;
        }
        
        if (inputs.toDate != null && inputs.fromDate == null) {
            inputs["fromDateerr"] = "Required";
            isValid = false;
        }
        
        if (inputs.toDate != null && inputs.fromDate != null) {
            
            const from = getDBDate(inputs.fromDate);
            const to = getDBDate(inputs.toDate);

            if (to < from) {

                inputs["toDateerr"] = "Cannot be less than from date";
                isValid = false;
            }
        }

        if (this.state.messageType == "MSG_POLL" || this.state.messageType == "MSG_FORM") {

            var isAllFilled = true;
            var isAllInputTypeSelected = true;
            var allChoicesFilled = true;
            var size = 0;
            inputs.options.map((object, index) => {
                if (!object.isDeleted) {
                    size++;

                    if (object.optionText.length == 0) {
                        isAllFilled = false;
                    }

                    if (!object.optionType || object.optionType.length == 0) {
                        isAllInputTypeSelected = false;
                    }
                    else if (object.optionType != "TEXT") {

                        object.choices.map((choiceObj, choiceInd) => {
                            if (choiceObj.choice_label.trim().length == 0) {
                                allChoicesFilled = false;
                            }
                        })
                    }                    
                }
            });

            var minSize = 2;
            var sizeError = "At least 2 options required for a POLL";
            var fillError = "Please fill all the options";
            if (this.state.messageType == "MSG_FORM") {
                minSize = 1;
                sizeError = "At least 1 field required in the form";
                fillError = "Please fill all the form field names";
            }

            if (size < minSize) {
                inputs["optionserr"] = sizeError;
                isValid = false;
            }
            else if (!isAllFilled) {

                inputs["optionserr"] = fillError;
                isValid = false;
            }
            else {

                if (this.state.messageType == "MSG_FORM") {
                    if (!isAllInputTypeSelected) {
                        inputs["optionserr"] = "Please select input type for all input fields";
                        isValid = false;
                    }
                    else if (!allChoicesFilled) {
                        inputs["optionserr"] = "Please fill all the choices for the inputs";
                        isValid = false;
                    }
                }
            }
        }

        if (!isValid) {
            this.setState({ inputs: inputs, selectedGroupError: selectedGroupError });
        }
        else {
            this.props.showConfirmation(
                "Confirmation",
                "Do you want to send this Message?",
                "Yes",
                "No",
                null,
                () => { this.submitForm() }
            );
        }
    }

    submitForm() {

        this.props.showPageSpinner(true);

        let connector = new ServerConnector();
        var dataMap = {
            _action_code: "CREATE_GROUP_MESSAGE",
            type: this.state.messageType,
            message: urlEncode(this.state.inputs.message)
        };

        if (this.state.message_seq != -999) {
            dataMap["_action_code"] = "UPDATE_GROUP_MESSAGE";
            dataMap["message_seq"] = this.state.message_seq;
        }

        if (this.state.inputs.toDate != null && this.state.inputs.fromDate != null) {
            dataMap["from_date"] = getDBDate(this.state.inputs.fromDate) + " 00:00:00";
            dataMap["to_date"] = getDBDate(this.state.inputs.toDate) + " 23:59:59";
        }
        
        const successMethod = (data) => {

            this.props.showPageSpinner(false);

            var messageSeq = this.state.message_seq;
            if (this.state.message_seq == -999) {
                messageSeq = data.data.message_seq;
                this.setState({message_seq: data.data.message_seq});
            }

            if (this.state.messageType == "MSG_POLL" || this.state.messageType == "MSG_FORM") {

                this.savePollOptions(messageSeq, 0);
            }
            else {

                this.postMessage(messageSeq);
            }
        };
        
        const failureMethod = (err_cd, msg, data) => {

            this.props.showPageSpinner(false);

            if (data && data.data) {

                let inputs = this.state.inputs;

                for (let key in data.data) {

                    inputs[key + "err"] = data.data[key];
                }

                this.setState({
                    inputs: inputs
                });
                return;
            }

            this.props.showAlert("Error", msg, "Ok", null, null);
        };

        let imageHashMap = [];

        if (this.state.inputs.uploadImage) {

            imageHashMap.push({
                fieldName: "image",
                file: this.state.inputs.uploadImage,
                fileName: this.state.inputs.uploadImage.name,
            });
        }
        
        if (this.state.inputs.uploadPdf) {

            imageHashMap.push({
                fieldName: "file",
                file: this.state.inputs.uploadPdf,
                fileName: this.state.inputs.uploadPdf.name,
            });
        }

        if (imageHashMap.length > 0) {

            connector.postDataMultiPartCustom(dataMap, imageHashMap, successMethod, failureMethod);
        }
        else {

            connector.postData(dataMap, successMethod, failureMethod);
        }
    }

    handleRecipientSelection(setSeqList) {
        this.setState({selectedGroup: setSeqList, selectedGroupError: ""});
    }

    postMessage(messageSeq) {

        var setData = [];
        for (var i=0;i<this.state.selectedGroup.length;i++) {
            setData.push({
                seq: this.state.selectedGroup[i].id,
                type: "SET"
            });
        }

        this.props.showPageSpinner(true);

        let connector = new ServerConnector();
        var dataMap = {
            _action_code: "POST_GROUP_MESSAGE",
            message_seq: messageSeq,
            set_seq: JSON.stringify(setData)
        };

        connector.postData(dataMap, (data) => { // success

            this.props.showPageSpinner(false);

            this.props.showAlert("Success", data.msg, "Ok", null, () => {
                this.props.navigate("messages_list")
            });

        }, (err_cd, msg, data) => { // failure

            this.props.showPageSpinner(false);
            this.props.showAlert("Error", msg, "Ok", null, null);
        })
    }
    
    savePollOptions(messageSeq, index) {

        const optionList = this.state.inputs.options;
        if (optionList.length == 0 || index < 0 || index >= optionList.length) {
            this.postMessage(messageSeq);
            return;
        }

        this.props.showPageSpinner(true);

        const option = optionList[index];
        var dataMap = null;

        if (option.isDeleted) {
            if (option.inputSeq != -1) {

                dataMap = {
                    _action_code: "REMOVE_MESSAGE_INPUT",
                    input_seq: option.inputSeq
                };
            }
        }
        else if (option.inputSeq != -1) {

            dataMap = {
                _action_code: "UPDATE_MESSAGE_INPUT",
                input_seq: option.inputSeq,
                option_label: option.optionText,
                display_order: String(index + 1),
            };
            if (this.state.messageType == "MSG_FORM") {
                dataMap["input_type"] = option.optionType;
            }
            else {
                dataMap["input_type"] = "TEXT";
            }
        }
        else if (option.inputSeq == -1) {

            dataMap = {
                _action_code: "ADD_MESSAGE_INPUT",
                message_seq: messageSeq,
                option_label: option.optionText,
                display_order: String(index + 1),
            };

            if (this.state.messageType == "MSG_FORM") {
                dataMap["input_type"] = option.optionType;
            }
            else {
                dataMap["input_type"] = "TEXT";
            }
        }

        if (dataMap != null) {

            let connector = new ServerConnector();
            connector.postData(dataMap, (data) => { // success

                this.props.showPageSpinner(false);

                if (dataMap._action_code == "ADD_MESSAGE_INPUT") {
                    option.inputSeq = data.data.input_seq;
                }

                if (this.state.messageType == "MSG_FORM") {

                    if (option.optionType != "TEXT") {

                        this.saveOptionChoices(option, 0, () => {
                            this.savePollOptions(messageSeq, index+1);
                        });
                    }
                    else {
                        this.savePollOptions(messageSeq, index+1);
                    }
                }
                else {

                    this.savePollOptions(messageSeq, index+1);
                }

            }, (err_cd, msg, data) => { // failure

                this.props.showPageSpinner(false);
                this.props.showAlert("Error", msg, "Ok", null, null);
                this.savePollOptions(messageSeq, index+1);
            })
        }
        else {

            this.savePollOptions(messageSeq, index+1);
        }
    }

    updateImageFile(files) {

        if (files) {

            this.updateInput("uploadImage", files[0]);
        }
    }
    
    updatePdfFile(files) {

        if (files && files[0]) {

            const extension = getFileExtensionFromName(files[0].name);

            if (extension != "pdf") {

                files = null;
                this.updateInput("uploadPdf", "");
                this.props.showAlert("Error", "Only PDF files accepted", "Ok", null, null);
            }
            else {

                this.updateInput("uploadPdf", files[0]);
            }
        }
        else {
            files = null;
            this.updateInput("uploadPdf", "");
        }
    }

    updateMessageType(messageType) {
        this.setState({messageType: messageType});
    }

    addOption() {

        var inputs = this.state.inputs;
        inputs.options.push({
            inputSeq: -1,
            optionText: "",
            isDeleted: false
        });
        inputs.optionserr = "";
        this.setState({inputs: inputs});
    }

    removeOption(index) {

        var inputs = this.state.inputs;
        inputs.options[index].isDeleted = true;
        inputs.optionserr = "";
        this.setState({inputs: inputs});
    }

    updateOptionText(value, index) {
        var inputs = this.state.inputs;
        inputs.options[index].optionText = value;
        inputs.optionserr = "";
        this.setState({inputs: inputs});
    }

    updateOptionType(value, index) {
        var inputs = this.state.inputs;
        inputs.options[index].optionType = value;

        if (value != "" && value != "TEXT") {

            if (!inputs.options[index].choices || inputs.options[index].choices.length == 0) {
                inputs.options[index].choices = [{choice_seq: -1, choice_label: ""}, {choice_seq: -1, choice_label: ""}];
            }
        }

        inputs.optionserr = "";
        this.setState({inputs: inputs});
    }

    handleChoiceUpdate(index, choiceInd, value) {
        var inputs = this.state.inputs;
        inputs.options[index].choices[choiceInd].choice_label = value;
        inputs.optionserr = "";
        this.setState({inputs: inputs});
    }

    handleChoiceOperation(index, operationType, choiceIndex, direction) {
        
        if (operationType == 'add') {
            var inputs = this.state.inputs;
            inputs.options[index].choices.push({choice_seq: -1, choice_label: ""});
            this.setState({inputs: inputs});
        }
        else if (operationType == 'remove') {
            var inputs = this.state.inputs;
            inputs.options[index].choices[choiceIndex].isDeleted = true;
            this.setState({inputs: inputs});
        }
        else if (operationType == 'move') {
            
            this.moveChoice(index, choiceIndex, direction);
        }
    }

    loadOptions() {

        this.props.showPageSpinner(true);

        let connector = new ServerConnector();
        let dataMap = {
            "_action_code": "GET_MESSAGE_INPUTS",
            "message_seq": this.state.message_seq
        }

        connector.postData(dataMap, (data) => { // success

            this.props.showPageSpinner(false);

            let inputs = this.state.inputs;
            inputs.options = [];

            data.data.map((object, index) => {

                var choices = object.choices;
                if (object.input_type != "TEXT") {
                    if (choices.length == 0) {
                        choices = [
                            {choice_seq: -1, choice_label: ""},
                            {choice_seq: -1, choice_label: ""}
                        ];
                    }
                }

                inputs.options.push({
                    inputSeq: object.input_seq,
                    optionText: object.option_label,
                    optionType: object.input_type,
                    choices: choices,
                    isDeleted: false
                });
            });
            
            this.setState({
                inputs: inputs
            });

        }, (err_cd, msg, data) => { // failure

            this.props.showPageSpinner(false);
        })
    }

    moveOption(index, direction) {

        var swapIndex = -1;

        if (direction == 'up') {
            
            for (var i=index-1;i>=0;i--) {
                if (!this.state.inputs.options[i].isDeleted) {
                    swapIndex = i;
                    break;
                }
            }
        }
        else if (direction == 'down') {

            for (var i=index+1;i<this.state.inputs.options.length;i++) {
                if (!this.state.inputs.options[i].isDeleted) {
                    swapIndex = i;
                    break;
                }
            }
        }

        if (swapIndex != -1) {
            const swapItem = this.state.inputs.options[swapIndex];
            const currentItem = this.state.inputs.options[index];
            var inputs = this.state.inputs;
            inputs.options[swapIndex] = currentItem;
            inputs.options[index] = swapItem;

            this.setState({
                inputs: inputs
            });
        }
    }

    moveChoice(index, choiceInd, direction) {

        var swapIndex = -1;

        if (direction == 'up') {
            
            for (var i=choiceInd-1;i>=0;i--) {
                if (!this.state.inputs.options[index].choices[i].isDeleted) {
                    swapIndex = i;
                    break;
                }
            }
        }
        else if (direction == 'down') {

            for (var i=choiceInd+1;i<this.state.inputs.options[index].choices.length;i++) {
                if (!this.state.inputs.options[index].choices[i].isDeleted) {
                    swapIndex = i;
                    break;
                }
            }
        }

        if (swapIndex != -1) {
            const swapItem = this.state.inputs.options[index].choices[swapIndex];
            const currentItem = this.state.inputs.options[index].choices[choiceInd];
            var inputs = this.state.inputs;
            inputs.options[index].choices[swapIndex] = currentItem;
            inputs.options[index].choices[choiceInd] = swapItem;

            this.setState({
                inputs: inputs
            });
        }
    }

    saveOptionChoices(option, choiceIndex, callBack) {

        const choiceList = option.choices;
        if (choiceList.length == 0 || choiceIndex < 0 || choiceIndex >= choiceList.length) {
            callBack();
            return;
        }

        this.props.showPageSpinner(true);

        const choice = choiceList[choiceIndex];
        var dataMap = null;

        if (choice.isDeleted) {
            if (choice.choice_seq != -1) {

                dataMap = {
                    _action_code: "DELETE_MESSAGE_INPUT_CHOICE",
                    choice_seq: choice.choice_seq
                };
            }
        }
        else if (choice.choice_seq != undefined && choice.choice_seq != -1) {

            dataMap = {
                _action_code: "UPDATE_MESSAGE_INPUT_CHOICE",
                choice_seq: choice.choice_seq,
                choice_label: choice.choice_label,
                display_order: String(choiceIndex + 1),
            };
        }
        else if (choice.choice_seq == -1) {

            dataMap = {
                _action_code: "ADD_MESSAGE_INPUT_CHOICE",
                input_seq: option.inputSeq,
                choice_label: choice.choice_label,
                display_order: String(choiceIndex + 1),
            };
        }

        if (dataMap != null) {

            let connector = new ServerConnector();
            connector.postData(dataMap, (data) => { // success

                this.props.showPageSpinner(false);
                this.saveOptionChoices(option, choiceIndex+1, callBack);

            }, (err_cd, msg, data) => { // failure

                this.props.showPageSpinner(false);
                this.props.showAlert("Error", msg, "Ok", null, null);
                this.saveOptionChoices(option, choiceIndex+1, callBack);
            })
        }
        else {

            this.saveOptionChoices(option, choiceIndex+1, callBack);
        }
    }

    render() {

        var options = [];
        this.state.messageGroupList.map((object, index) => {

            options.push({name: object.set_name, id: object.set_seq});
        });

        var minSize = 2;
        if (this.state.messageType == "MSG_FORM") {
            minSize = 1;
        }

        var sizeOfOptions = 0;
        var lastOptionIndex = -1;
        var firstOptionIndex = -1;
        this.state.inputs.options.map((object, index) => {
            if (!object.isDeleted) {
                sizeOfOptions++;
                lastOptionIndex = index;

                if (firstOptionIndex == -1) {
                    firstOptionIndex = index;
                }
            }
        });

        return (
            <>
                <PageHeader
                    page_name={this.props.page_name}
                    onBackPressed={() => this.props.navigate("messages_list")} />
                <CCardGroup>
                    <CCard className="p-4">
                        <CCardBody>
                            <CForm className="row g-3">
                                <CCol md="12">
                                    <CButtonGroup role="messageTypeGroup" aria-label="Message Type">
                                        <CFormCheck
                                            type="radio"
                                            button={{ color: 'primary', variant: 'outline' }}
                                            name="messageType"
                                            id="messageTypeMessage"
                                            autoComplete="off"
                                            label="Text/ Image Message"
                                            checked={this.state.messageType == "MESSAGE"}
                                            onChange={(event) => {event.target.checked ? this.updateMessageType("MESSAGE") : null}}
                                            disabled={this.state.message_seq != -999}
                                        />
                                        <CFormCheck
                                            type="radio"
                                            button={{ color: 'primary', variant: 'outline' }}
                                            name="messageType"
                                            id="messageTypePdf"
                                            autoComplete="off"
                                            label="PDF Message"
                                            checked={this.state.messageType == "MSG_FILE"}
                                            onChange={(event) => {event.target.checked ? this.updateMessageType("MSG_FILE") : null}}
                                            disabled={this.state.message_seq != -999}
                                        />
                                        <CFormCheck
                                            type="radio"
                                            button={{ color: 'primary', variant: 'outline' }}
                                            name="messageType"
                                            id="messageTypePoll"
                                            autoComplete="off"
                                            label="Poll Message"
                                            checked={this.state.messageType == "MSG_POLL"}
                                            onChange={(event) => {event.target.checked ? this.updateMessageType("MSG_POLL") : null}}
                                            disabled={this.state.message_seq != -999}
                                        />
                                        <CFormCheck
                                            type="radio"
                                            button={{ color: 'primary', variant: 'outline' }}
                                            name="messageType"
                                            id="messageTypeForm"
                                            autoComplete="off"
                                            label="Form Message"
                                            checked={this.state.messageType == "MSG_FORM"}
                                            onChange={(event) => {event.target.checked ? this.updateMessageType("MSG_FORM") : null}}
                                            disabled={this.state.message_seq != -999}
                                        />
                                    </CButtonGroup>
                                </CCol>
                                <CCol md="12">
                                    <CFormLabel>Select Recipients *</CFormLabel>
                                    {
                                        this.state.messageGroupDropdownSpinner ? 
                                            <CSpinner color="primary" size="sm" className="inlineBlock"/> 
                                        : 
                                            <Multiselect
                                                options={options}
                                                selectedValues={this.state.selectedGroup}
                                                onSelect={(selectedList, selectedItem) => this.handleRecipientSelection(selectedList)}
                                                onRemove={(selectedList, removedItem) => this.handleRecipientSelection(selectedList)}
                                                displayValue="name"
                                                placeholder="Select Recipients" />
                                    }
                                    <div className="inputError">
                                        {this.state.selectedGroupError}
                                    </div>
                                </CCol>
                                <CCol md={6}>
                                    <CFormLabel htmlFor="messageText">Message *</CFormLabel>
                                    <CFormTextarea
                                        id="messageText" 
                                        rows={3} 
                                        maxLength="1024"
                                        onChange={(event) => { this.updateInput("message", event.target.value) }}
                                        placeholder='Enter Message here...'
                                        value={this.state.inputs.message} />
                                    <div className="inputError">
                                        {this.state.inputs.messageerr}
                                    </div>
                                </CCol>
                                {
                                    this.state.messageType != "MSG_POLL" && this.state.messageType != "MSG_FORM" ?
                                        <CCol md={6}>
                                            <CFormLabel htmlFor="uploadImage">
                                                Upload Image
                                                {
                                                    this.state.inputs.uploadedImageUrl.length > 0 ?
                                                        <CLink
                                                            href={this.state.inputs.uploadedImageUrl}
                                                            target="_blank"
                                                            className="text-white bg-info px-2"
                                                            style={{marginLeft: 10, textDecoration: "none"}} >
                                                            Click here to view uploaded image
                                                        </CLink>
                                                    : null
                                                }
                                            </CFormLabel>
                                            <CFormInput
                                                id="uploadImage"
                                                type="file"
                                                accept="image/*"
                                                onChange={e => { this.updateImageFile(e.target.files) }} />
                                            <div className="inputError">
                                                {this.state.inputs.uploadImageerr}
                                            </div>
                                        </CCol>
                                    : null
                                }
                                {
                                    this.state.messageType == "MSG_FILE" ?
                                        <CCol md={6}>
                                            <CFormLabel htmlFor="uploadPdf">
                                                Upload PDF *
                                                {
                                                    this.state.inputs.uploadedPdfUrl.length > 0 ?
                                                        <CLink
                                                            href={this.state.inputs.uploadedPdfUrl}
                                                            target="_blank"
                                                            className="text-white bg-info px-2"
                                                            style={{marginLeft: 10, textDecoration: "none"}} >
                                                            Click here to view uploaded file
                                                        </CLink>
                                                    : null
                                                }
                                            </CFormLabel>
                                            <CFormInput
                                                id="uploadPdf"
                                                type="file"
                                                accept="application/pdf"
                                                onChange={e => { this.updatePdfFile(e.target.files) }} />
                                            <div className="inputError">
                                                {this.state.inputs.uploadPdferr}
                                            </div>
                                        </CCol>
                                    : null
                                }
                                {
                                    this.state.messageType == "MSG_POLL" || this.state.messageType == "MSG_FORM" ?
                                        <CCol md={3}>
                                            <CFormLabel>From Date</CFormLabel>
                                            <br/>
                                            <DatePicker
                                                onChange={(value) => this.updateInput("fromDate", value)} 
                                                value={this.state.inputs.fromDate}
                                                format="dd/MM/y"
                                                dayPlaceholder="dd"
                                                monthPlaceholder="MM"
                                                yearPlaceholder="yyyy"
                                                showLeadingZeros={true}
                                                clearIcon={null}
                                                maxDate={new Date(this.today.getFullYear() + 1, this.today.getMonth(), this.today.getDate())}
                                                minDate={new Date()} />
                                            <div className="inputError">
                                                {this.state.inputs.fromDateerr}
                                            </div>
                                        </CCol>
                                    : null
                                }
                                {
                                    this.state.messageType == "MSG_POLL" || this.state.messageType == "MSG_FORM" ?
                                        <CCol md={3}>
                                            <CFormLabel>To Date</CFormLabel>
                                            <br/>
                                            <DatePicker
                                                onChange={(value) => this.updateInput("toDate", value)} 
                                                value={this.state.inputs.toDate}
                                                format="dd/MM/y"
                                                dayPlaceholder="dd"
                                                monthPlaceholder="MM"
                                                yearPlaceholder="yyyy"
                                                showLeadingZeros={true}
                                                clearIcon={null}
                                                maxDate={new Date(this.today.getFullYear() + 1, this.today.getMonth(), this.today.getDate())}
                                                minDate={new Date()} />
                                            <div className="inputError">
                                                {this.state.inputs.toDateerr}
                                            </div>
                                        </CCol>
                                    : null
                                }
                                {
                                    this.state.messageType == "MSG_POLL" ?
                                        this.state.inputs.options.map((object, index) => {

                                            if (object.isDeleted) return null;

                                            return(
                                                <CCol md={12} key={index}>
                                                    <CFormInput 
                                                        type="text" 
                                                        maxLength="512"
                                                        onChange={(event) => { this.updateOptionText(event.target.value, index) }}
                                                        value={object.optionText}
                                                        placeholder={this.state.messageType == "MSG_POLL" ? "Option" : "Field Name"}
                                                        style={{width: '30%', display: 'inline'}} />

                                                        {
                                                            index == lastOptionIndex ?
                                                                <AppButton
                                                                    size="sm"
                                                                    name=""
                                                                    color="primary"
                                                                    icon={cilPlus}
                                                                    isLoading={false}
                                                                    onClick={() => this.addOption()}
                                                                    style={{marginLeft: 10}}>
                                                                </AppButton>
                                                            : null
                                                        }
                                                        {
                                                            sizeOfOptions > minSize ?
                                                                <AppButton
                                                                    size="sm"
                                                                    name=""
                                                                    color="danger"
                                                                    icon={cilDelete}
                                                                    isLoading={false}
                                                                    onClick={() => this.removeOption(index)}
                                                                    style={{marginLeft: 10}}>
                                                                </AppButton>
                                                            : null
                                                        }
                                                        <AppButton
                                                            size="sm"
                                                            name=""
                                                            color="warning"
                                                            icon={cilArrowTop}
                                                            isLoading={false}
                                                            onClick={() => this.moveOption(index, 'up')}
                                                            style={{marginLeft: 10}}
                                                            disabled={index == firstOptionIndex}>
                                                        </AppButton>
                                                        <AppButton
                                                            size="sm"
                                                            name=""
                                                            color="warning"
                                                            icon={cilArrowBottom}
                                                            isLoading={false}
                                                            onClick={() => this.moveOption(index, 'down')}
                                                            style={{marginLeft: 10}}
                                                            disabled={index == lastOptionIndex}>
                                                        </AppButton>
                                                </CCol>
                                            );
                                        })
                                    : null
                                }
                                {
                                    this.state.messageType == "MSG_FORM" ?
                                        <FormInputs
                                            options={this.state.inputs.options}
                                            onOptionUpdate={(index, value, input) => {

                                                if (input == "inputType") {
                                                    this.updateOptionType(value, index);
                                                }
                                                else if (input == "inputText") {
                                                    this.updateOptionText(value, index)
                                                }
                                            }}
                                            onOptionsChoiceUpdate={(index, choiceInd, value) => {this.handleChoiceUpdate(index, choiceInd, value)}}
                                            choiceOperationUpdate={(index, operationType, choiceIndex, direction) => this.handleChoiceOperation(index, operationType, choiceIndex, direction)}
                                            lastOptionIndex={lastOptionIndex}
                                            firstOptionIndex={firstOptionIndex}
                                            sizeOfOptions={sizeOfOptions}
                                            minSize={minSize}
                                            addOption={() => this.addOption()}
                                            removeOption={(index) => this.removeOption(index)}
                                            moveOption={(index, direction) => this.moveOption(index, direction)} />
                                    : null
                                }
                                <div className="inputError">
                                    {this.state.inputs.optionserr}
                                </div>
                                <CRow className="mt-4">
                                    <CCol xs={12} className="alignCenter">
                                        <AppButton
                                            size="md"
                                            name="Send Message"
                                            color="primary"
                                            icon={cilSend}
                                            isLoading={false}
                                            onClick={() => this.validateForm()}>
                                            Submit
                                        </AppButton>
                                    </CCol>
                                </CRow>
                            </CForm>
                        </CCardBody>
                    </CCard>
                </CCardGroup>
            </>
        );
    }
}

function FormInputs({
    options=[],
    onOptionUpdate=null,
    onOptionsChoiceUpdate=null,
    choiceOperationUpdate,
    lastOptionIndex,
    firstOptionIndex,
    sizeOfOptions,
    minSize,
    addOption,
    removeOption,
    moveOption
}) {

    const handleInputTypeUpdate = (index, value) => {
        if (onOptionUpdate) {
            onOptionUpdate(index, value, "inputType");
        }
    }

    const handleOptionText = (index, value) => {
        if (onOptionUpdate) {
            onOptionUpdate(index, value, "inputText");
        }
    }

    const handleChoiceText = (index, choiceIndex, value) => {
        if (onOptionsChoiceUpdate) {
            onOptionsChoiceUpdate(index, choiceIndex, value);
        }
    }

    return options.map((object, index) => {

        if (object.isDeleted) return null;

        return(
            <>
                <h6>Input Field</h6>
                <CCol md={8} key={"form"+index} className='formInputFieldSection'>
                    <CFormSelect value={object.optionType ? object.optionType : ""}
                        onChange={(event) => { handleInputTypeUpdate(index, event.target.value) }}>
                        <option value="">Select Input Type</option>
                        {
                            inputTypes.map((inputTypeObj, inputIndex) => {
                                return (
                                    <option key={String(inputIndex) +"_" + inputTypeObj.id} value={inputTypeObj.id}>
                                        {inputTypeObj.name}
                                    </option>
                                )
                            })
                        }
                    </CFormSelect>

                    {
                        object.optionType != undefined && object.optionType != null && object.optionType != "" ?
                        <CFormInput
                            type="text" 
                            maxLength="512"
                            onChange={(event) => { handleOptionText(index, event.target.value) }}
                            value={object.optionText}
                            placeholder="Field Name"
                            style={{width: '100%', display: 'inline', marginTop: 10}} />
                        : null
                    }

                    {
                        object.optionType != undefined && object.optionType != null && object.optionType != "" && object.optionType != "TEXT" ?
                            <InputChoices 
                                choices={object.choices ? object.choices : []}
                                onInputChange={(choiceInd, choiceText) => handleChoiceText(index, choiceInd, choiceText)}
                                choiceOperationUpdate={(operationType, choiceIndex, direction) => choiceOperationUpdate(index, operationType, choiceIndex, direction)} />
                        : null
                    }
                </CCol>
                <CCol md={4} key={"form_"+index}>
                    {
                        index == lastOptionIndex ?
                            <AppButton
                                size="sm"
                                name=""
                                color="primary"
                                icon={cilPlus}
                                isLoading={false}
                                onClick={() => addOption()}
                                style={{marginLeft: 10}}>
                            </AppButton>
                        : null
                    }
                    {
                        sizeOfOptions > minSize ?
                            <AppButton
                                size="sm"
                                name=""
                                color="danger"
                                icon={cilDelete}
                                isLoading={false}
                                onClick={() => removeOption(index)}
                                style={{marginLeft: 10}}>
                            </AppButton>
                        : null
                    }
                    <AppButton
                        size="sm"
                        name=""
                        color="warning"
                        icon={cilArrowTop}
                        isLoading={false}
                        onClick={() => moveOption(index, 'up')}
                        style={{marginLeft: 10}}
                        disabled={index == firstOptionIndex}>
                    </AppButton>
                    <AppButton
                        size="sm"
                        name=""
                        color="warning"
                        icon={cilArrowBottom}
                        isLoading={false}
                        onClick={() => moveOption(index, 'down')}
                        style={{marginLeft: 10}}
                        disabled={index == lastOptionIndex}>
                    </AppButton>
                </CCol>
            </>
        );
    });
}

function InputChoices({
    choices=[],
    onInputChange=null,
    choiceOperationUpdate=null
}) {

    var sizeOfChoices = 0;
    var lastChoiceIndex = -1;
    var firstChoiceIndex = -1;
    choices.map((object, index) => {
        if (!object.isDeleted) {
            sizeOfChoices++;
            lastChoiceIndex = index;
            if (firstChoiceIndex == -1) {
                firstChoiceIndex = index;
            }
        }
    });

    const handleInputChange = (value, index) => {

        if (onInputChange) {
            onInputChange(index, value);
        }
    }

    return choices.map((object, index) => {

        if (object.isDeleted) return null;

        return(
            <>
                <CCol md={12} key={"choice"+index} style={{display: "inline-block"}} >
                    <CFormInput
                        type="text" 
                        maxLength="512"
                        onChange={(event) => { handleInputChange(event.target.value, index) }}
                        value={object.choice_label}
                        placeholder="Choice Name"
                        style={{width: '60%', display: 'inline', marginTop: 10, marginLeft: 10}} />

                    {
                        index == lastChoiceIndex ?
                            <AppButton
                                size="xs"
                                name=""
                                color="primary"
                                icon={cilPlus}
                                isLoading={false}
                                onClick={() => {if (choiceOperationUpdate) choiceOperationUpdate('add')}}
                                style={{marginLeft: 10}}>
                            </AppButton>
                        : null
                    }
                    {
                        sizeOfChoices > 2 ?
                            <AppButton
                                size="xs"
                                name=""
                                color="danger"
                                icon={cilDelete}
                                isLoading={false}
                                onClick={() => {if (choiceOperationUpdate) choiceOperationUpdate('remove', index)}}
                                style={{marginLeft: 10}}>
                            </AppButton>
                        : null
                    }
                    <AppButton
                        size="sm"
                        name=""
                        color="warning"
                        icon={cilArrowTop}
                        isLoading={false}
                        onClick={() => {if (choiceOperationUpdate) choiceOperationUpdate('move', index, 'up')}}
                        style={{marginLeft: 10}}
                        disabled={index == firstChoiceIndex}>
                    </AppButton>
                    <AppButton
                        size="sm"
                        name=""
                        color="warning"
                        icon={cilArrowBottom}
                        isLoading={false}
                        onClick={() => {if (choiceOperationUpdate) choiceOperationUpdate('move', index, 'down')}}
                        style={{marginLeft: 10}}
                        disabled={index == lastChoiceIndex}>
                    </AppButton>
                </CCol>
            </>
        );
    });
}

export default SendMessage;